import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import { GridList } from 'material-ui/GridList'
import Chip from 'material-ui/Chip'
import Avatar from 'material-ui/Avatar'
import SvgIconDone from 'material-ui/svg-icons/action/done'
import SvgIconUndone from 'material-ui/svg-icons/action/schedule'
import * as firebase from 'firebase'
import { connect } from 'react-redux'

import PhotoItem from '../../schedule/common/modules/photos/PhotoItem'
import PhotoSlideShow from 'common/PhotoSlideShow/SlideShow'
import ModulesUtils from '../../infra/ModulesUtils'
import Config from './ServiceColumnConfig.js'
import TimeFormatter from 'infra/TimeFormatter'
import { TimeUtils } from '@fibo-app/fibo-collab-shared'

const FONT_SIZE = 12

const OVERALL_MARGIN = {
  marginLeft: 10,
  marginRight: 10,
  marginTop: 8,
  marginBottom: 4
}

class ServiceRow extends React.Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    dateStr: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      preparedData: {},
      fullscreenVisible: false,
      selectedIdx: 0
    };
    this.commonInfo = {};
    this.extendedInfo = {};
    this.eventId = '';
    this.index = 0;
    this.dateStr = null;
    this.commonInfoListener = this.onUpdate.bind(this, 'commonInfo')
    this.extendedInfoListener = this.onUpdate.bind(this, 'extendedInfo')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.eventId !== this.props.eventId
        || nextProps.dateStr !== this.props.dateStr) {
      this.detachLoader(this.props.eventId, this.props.index);
      this.eventId = nextProps.eventId;
      this.index = nextProps.index;
      this.dateStr = nextProps.dateStr;
      this.initLoader(this.eventId);
    }
    else
    if (nextProps.headers.length !== this.props.headers.length){
      this.updateData(nextProps);
    }
  }

  componentWillMount() {
    this.eventId = this.props.eventId;
    this.reportData = this.props.reportData;
    this.index = this.props.index;
    this.dateStr = this.props.dateStr;
    this.initLoader(this.eventId);
  }

  componentWillUnmount() {
    this.eventId = '';
    this.detachLoader(this.props.eventId, this.props.index);
  }

  //
  // Firebase Listeners And Update Function
  //
  initLoader(eventId) {
    // Start querying and listening for changes
    const dbPath_commonInfo = `events/${eventId}/commonInfo`;
    const dbPath_extendedInfo = `events/${eventId}/extendedInfo`;
    firebase.database().ref(dbPath_commonInfo).on('value', this.commonInfoListener);
    firebase.database().ref(dbPath_extendedInfo).on('value', this.extendedInfoListener);
  }

  detachLoader(eventId, index) {
    this.props.dispatch({
      type: 'REPORTS_DELETE_SERVICE',
      label: 'SERVICE_DATA',
      value: { index }
    });

    this.commonInfo = {};
    this.extendedInfo = {};
    const dbPath_commonInfo = `events/${eventId}/commonInfo`;
    const dbPath_extendedInfo = `events/${eventId}/extendedInfo`;
    firebase.database().ref(dbPath_commonInfo).off('value', this.commonInfoListener);
    firebase.database().ref(dbPath_extendedInfo).off('value', this.extendedInfoListener);
  }

  onUpdate = (type, snapshot) => {
    const value = snapshot.val()
    if (value){
      if (type === 'commonInfo') {
        this.commonInfo = value
      } else if (type === 'extendedInfo') {
        this.extendedInfo = value
      }
      this.updateData(this.props)
    }
  }

  //
  // Data Processor Functions
  //

  //Update data after columns or eventId changes
  updateData = (props) => {
    const viewHeaders = props.headers.slice();
    viewHeaders.unshift('index') //index should always be first
    const preparedData = this.prepareData(viewHeaders, this.dateStr, this.eventId);
    this.setState({preparedData});

    //notify redux
    const data = {}
    data[this.index] = {eventId: this.eventId, data: preparedData}
    this.props.dispatch({
      type: 'REPORTS_SET_SERVICE',
      label: 'SERVICE_DATA',
      value: data
    });
  }

  //Extract data from right location

  prepareData = (headers, dateStr, eventId) => {
    const result = {};
    headers.forEach(header => {
      let moduleInfo;
      if (this.commonInfo.modules) {
        moduleInfo = Config.modules[header].location({
          commonInfo: this.commonInfo,
          extendedInfo: this.extendedInfo
        }, dateStr);
      }
      if (moduleInfo) {
        result[header] = this.processData(header, moduleInfo, eventId, this.commonInfo, dateStr);
      }
    })
    return result;
  }

  //Process, filter and transform data
  processData(header, data, eventId, commonInfo, dateStr){
    switch (header){
      case 'displayName':
        return data;
      case 'address':
        return data;
      case 'contactInfo':
        return {name: data.name, phoneNumber: data.phoneNumber, email: data.email}
      case 'contactId':
        return {id: data.id}
      case 'date': {
        return data
      }
      case 'description':
        return data;
      case 'materials': {
        const materialsList = [];
        Object.keys(data)
          .forEach(key => {
            const material = data[key];
            if (!material.delete &&
                (!material.jobDateStr || material.jobDateStr.indexOf(dateStr) !== -1)){
              materialsList.push(material)
            }
          })
        return materialsList;
      }
      case 'photos': {
        const photosList = [];
        Object.keys(data)
          .forEach((key) => {
            const photo = data[key];
            const value = Object.assign({}, photo, {dbKey: key});
            if (!value.delete &&
                (!value.jobDateStr || value.jobDateStr.indexOf(dateStr) !== -1)){
              photosList.push(value);
            }
          })
        return photosList.reverse();
      }
      case 'tasks': {
        const tasksList = [];
        Object.keys(data)
          .forEach(key => {
            const task = data[key];
            const date = task && task.creationDate && task.creationDate.split(" ")[0];
            tasksList.push({
              text: task.text,
              date,
              done: task.done,
              deleted: task.deleted
            })
          })
        return tasksList;
      }
      case 'notes': {
        const result = [];
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const name = ModulesUtils.getMemberName(this.props.teamMembers, key);
            const note = data[key].value;
            result.push(name + ': ' + (note ? note : ''));
          }
        }
        return result;
      }
      case 'workers': {
        let result = [];
        for (const key in data) {
          if (!data.hasOwnProperty(key)) {
            continue;
          }
          result.push(ModulesUtils.getMemberName(this.props.teamMembers, key));
        }
        return result;
      }
      case 'assistants':
      case 'laborers':
      {
        const result = data && data.list ? Object.keys(data.list) : [];
        return result;
      }
      case 'target':
        if (data.target){
          return {target: data.target};
        }
        return '';
      case 'actual': {
        const workers = commonInfo.modules['workers']
        let diff = 0
        if (data) {
          if (commonInfo.modules['clockingExtended']) {
            const numberOfWorkers = (!workers || !workers.list) ? 1 : Object.keys(workers.list).length
            diff = TimeUtils.getIntervalTimeFromEvent(data) * numberOfWorkers
          }
          else
          if (commonInfo.modules['clockingWorker']) {
            for (const workerId in data) {
              diff += TimeUtils.getIntervalTimeFromEvent(data[workerId])
            }
          }
          else
          if (commonInfo.modules['clockingTeam']) {
            for (const key in data) {
              if (!data.hasOwnProperty(key)) {
                continue;
              }
              diff += TimeUtils.getIntervalTimeFromEvent(data[key])
            }
          }
        }
        return { target: data.target, diff }
      }
      case 'clockInOut': {
        if (data) {
          if (commonInfo.modules['clockingExtended']) {
            return { type: 'clockingExtended', start: data.timeIn, end: data.timeOut }
          }
          if (commonInfo.modules['clockingWorker']) {
            return { type: 'clockingWorker', list: data }
          }
        }
        break
      }
      case 'jobType': {
        return data
      }
    }
  }

  //
  // UI Processor Functions
  //

  getWorkers(workers) {
    if (workers){
      return workers.join(', ');
    }
    return "";
  }

  getLabels(labels) {
    if (labels){
      return labels.join(', ');
    }
    return "";
  }

  getTarget(data) {
    if (data && data.target){
      return data.target
    }
    return 0;
  }

  getActual(data) {
    return data && data.diff
  }

  getNotes(notes) {
    const notesList = [];
    if (notes){
      notes.forEach((note, idx) => {
        notesList.push(
          //styling- wrapping text with indent
          <div key={idx} style={{overflowX: 'auto', paddingLeft: 10, textIndent:-8, fontSize: FONT_SIZE}}>
            {`- ${note}`}
          </div>
        )
      })
    }

    return notesList;
  }

  getDescription(description) {
    return description || '';
  }

  getAddress(address) {
    return address || '';
  }

  getContactId(contact){
    return contact && contact.id ? contact.id : '';
  }

  getContactInfo(contact){
    let result = '';
    if (contact && contact.name) {
      result += contact.name;
    }
    if (contact && contact.phoneNumber) {
      result += `, ${contact.phoneNumber}`
    }
    if (contact && contact.email) {
      result += `, ${contact.email}`
    }
    return result;
  }

  getJobType(data) {
    if (data) {
      return data.typeInfo
    }
  }

  onImagePress = (selectedIdx) => {
    this.setState({ fullscreenVisible: true, selectedIdx })
  }

  onSlideShowClose = () => {
    this.setState({ fullscreenVisible: false})
  }

  getPhotos = (gridWidth, photos) => {
    const photosList = [];
    const cellHeight = 64;
    const cellWidth = 64;
    const padding = 5;
    const photosListDbPath = `events/${this.props.eventId}/extendedInfo/modules/photos/list`

    if (photos && photos.length > 0){
      photos.forEach((photo, key) => {
        photosList.push(
          <PhotoItem
            key={key}
            storagePath={photo.dbPath}
            dbPath={`events/${this.props.eventId}/extendedInfo/modules/photos/list/${photo.dbKey}`}
            photo={photo}
            width={cellWidth}
            height={cellHeight}
            onPress={this.onImagePress.bind(this, key)} />
        );
      })

      const GridHeight = 1 * (cellHeight + 8 * padding); //take into account gridtile's padding
      const colsInView = (gridWidth / (cellWidth + 2 * padding)) + 0.3; //reverse calc here than photosmodule

      return (
        <div
          style={{
            width: gridWidth,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around'
          }}>
          <GridList
            style={{
              width:gridWidth,
              height: GridHeight,
              overflowX: 'auto',
              flexWrap: 'nowrap'
            }}
            cols={colsInView}
            cellHeight={cellHeight}
            padding={padding}>
            {photosList}
          </GridList>
          <PhotoSlideShow
            visible={this.state.fullscreenVisible}
            index={this.state.selectedIdx}
            photos={photos}
            photosListDbPath={photosListDbPath}
            onClose={this.onSlideShowClose}/>
        </div>
      )
    }
  }

  getTasks = (tasks) => {
    const tasksList = []
    if (tasks){
      tasks.forEach((task, idx) => {
        if (!task.deleted) {
          tasksList.push(
            <Chip key={idx}
              style={{ overflowX: 'auto', margin: 4, backgroundColor: 'transparent' }}
              labelStyle={{fontSize: FONT_SIZE}}>
              <Avatar color="#4d6f7f" icon={task.done ? <SvgIconDone /> : <SvgIconUndone /> } />
              { task.text }
            </Chip>
          )
        }
      })
    }
    return tasksList
  }

  getMaterials = (materials) => {
    const materialsList = [];
    if (materials){
      materials.forEach((material) => {
        if (!material.delete){
          let cost = '';
          if (material.cost){
            cost = `$${material.cost},`
          }
          materialsList.push(
            //styling- wrapping text with indent
            <Chip key={material.id}
              style={{overflowX: 'auto', margin: 4, backgroundColor: 'transparent', border:'solid 1px #4d6f7f'}}
              labelStyle={{fontSize: FONT_SIZE}}>
              {`${material.name} - ${cost} ${material.quantity} ${material.units}`}
            </Chip>
          )
        }
      })
    }

    return materialsList;
  }

  renderTargetTime = (time, columnWidth) => {
    if (!time) {
      return <div key={'target'} style={{ display: 'flex', alignSelf: 'flex-start', justifyContent: 'center', flexShrink: 0, width: columnWidth, fontSize: FONT_SIZE, ...OVERALL_MARGIN}}/>
    }
    return (
      <div
        key={'target'}
        style={{ display: 'flex', alignSelf: 'flex-start', justifyContent: 'flex-start', flexShrink: 0, paddingTop: 0,
          width: columnWidth, ...OVERALL_MARGIN}}>
        <div style={{display: 'flex', flexDirection: 'row', borderRadius: 3, backgroundColor: 'transparent',
          paddingLeft: 2, paddingRight: 2}}>
          <span
            style={{ display: 'flex', fontSize: FONT_SIZE, color: 'rgba(0,0,0,0.7)' }}>
            { TimeFormatter.toHoursMinutesFormat(time) }
          </span>
        </div>
      </div>
    )
  }

  renderActualTime = (time, target, columnWidth) => {
    if (!time) {
      return <div key={'actual'} style={{ display: 'flex', alignSelf: 'flex-start', justifyContent: 'center', flexShrink: 0, width: columnWidth, fontSize: FONT_SIZE, ...OVERALL_MARGIN}}/>
    }
    let textColor = 'rgba(0,0,0,0.7)'
    let backgroundColor = 'transparent'
    if (target) {
      if (time > target * 1.2) {
        textColor = '#fff'
        backgroundColor = '#bf6565'
      }
      else
      if (time < target * 0.8) {
        textColor = '#fff'
        backgroundColor = '#2E8B57'
      }
    }
    return (
      <div
        key={'actual'}
        style={{ display: 'flex', alignSelf: 'flex-start', justifyContent: 'flex-start', flexShrink: 0, paddingTop: 0,
          width: columnWidth, ...OVERALL_MARGIN}}>
        <div style={{display: 'flex', flexDirection: 'row', borderRadius: 3, backgroundColor, paddingLeft: 2, paddingRight: 2}}>
          <span
            style={{ display: 'flex', fontSize: FONT_SIZE, color: textColor }}>
            { TimeFormatter.toHoursMinutesFormat(time) }
          </span>
        </div>
      </div>
    )
  }

  renderClockInOut(data, key, columnWidth) {
    if (!data){
      return;
    }
    if (data.type === 'clockingExtended') {
      return (
        <div style={{borderRadius: 3, paddingLeft: 2, paddingRight: 2}}>
          <span
            style={{ fontSize: FONT_SIZE }}>
            {data.start} - {data.end}
          </span>
        </div>
      )
    }
    if (data.type === 'clockingWorker') {
      return (
        <div style={{borderRadius: 3, paddingLeft: 2, paddingRight: 2}}>
          { Object.keys(data.list).map(workerId => (
            <div key={workerId} style={{ fontSize: FONT_SIZE }}>
              { `- ${ModulesUtils.getMemberName(this.props.teamMembers, workerId)}: ${data.list[workerId].timeIn || ''} - ${data.list[workerId].timeOut || ''}` }
            </div>))
          }
        </div>
      )
    }
  }

  //
  // Main Render Function - calls data processor, then implements appropriate UI processor
  //

  render() {
    if (!this.commonInfo.modules) {
      return (
        <div
          style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: this.props.backgroundColor, ...OVERALL_MARGIN}}>

          <div
            style={{ width: 30, flexShrink: 0 }}>
            <span
              style={{ fontSize: FONT_SIZE }}>
              {this.props.index}
            </span>
          </div>

          <div
            style={{ display: 'flex', alignItems: 'center', height: '48px', flexShrink: 0, width: 120, overflow: 'auto' }}>
          </div>
        </div>
      )
    }

    // Do not show install jobs in this report
    if (this.commonInfo.modules.lineItems) {
      return null
    }

    const views = [];
    const viewHeaders = this.props.headers.slice();
    viewHeaders.unshift('index') //index should always be first
    const preparedData = this.state.preparedData;
    //user-selected views

    viewHeaders.forEach(header => {
      let key = header;
      let columnWidth = 100;
      if (Config.modules[header]){
        key = Config.modules[header]['key'];
        columnWidth = Config.modules[header]['columnWidth'];
      }

      switch (key) {
        case "index":
          views.push(
            <div key={key} style={{flex: 'display', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE, color: '#4d6f7f' }}>
                {this.props.index}
              </span>
            </div>
          );
          break;
        case "displayName":
          views.push(
            <FlatButton
              key={key}
              style={{
                display: 'flex',
                alignSelf: 'flex-start',
                flexShrink: 0,
              }}
              onTouchTap={() => this.props.onTouchTap(this.commonInfo)} >
              <div
                style={{ marginLeft: 10, marginRight: 10, display: 'flex', alignSelf: 'flex-start', flexShrink: 0, width: columnWidth, overflow: 'auto', }}>
                <span
                  style={{ overflow: 'hidden', fontWeight: 'bold',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: FONT_SIZE}}>
                  {preparedData['displayName'] ? preparedData['displayName'] : ''}
                </span>
              </div>
            </FlatButton>
          );
          break;
        case "target":
          views.push(this.renderTargetTime(this.getTarget(preparedData['target']), columnWidth))
          break;
        case "actual": {
          const actual = this.getActual(preparedData['actual'])
          const target = this.getTarget(preparedData['target'])
          views.push(this.renderActualTime(actual, target, columnWidth))
          break;
        }
        case "clockInOut":
          views.push(
            <div
              key={key}
              style={{ display: 'flex', alignSelf: 'flex-start', justifyContent: 'flex-start', flexShrink: 0,
                width: columnWidth, ...OVERALL_MARGIN}}>
              {this.renderClockInOut(preparedData['clockInOut'], key, columnWidth)}
            </div>
          );
          break;
        case "workers":
          views.push(

            <div key={key} style={{flex: 'display', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, overflow: 'hidden', ...OVERALL_MARGIN }}>
              <span
                style={{ display: 'block', overflow: 'hidden', fontSize: FONT_SIZE,
                  textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                {this.getWorkers(preparedData['workers'])}
              </span>
            </div>
          )
          break;
        case "assistants":
        case "laborers":
          views.push(

            <div key={key} style={{flex: 'display', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, overflow: 'hidden', ...OVERALL_MARGIN }}>
              <span
                style={{ display: 'block', overflow: 'hidden', fontSize: FONT_SIZE,
                  textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                {this.getLabels(preparedData[key])}
              </span>
            </div>
          )
          break;
        case 'notes':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getNotes(preparedData['notes'])}
              </span>
            </div>
          )
          break;
        case 'description':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getDescription(preparedData['description'])}
              </span>
            </div>
          )
          break;
        case 'materials':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', alignSelf: 'flex-start', width: columnWidth, flexShrink: 0, overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getMaterials(preparedData['materials'])}
              </span>
            </div>
          )
          break;
        case 'tasks':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', width: columnWidth, flexShrink: 0, overflow: 'auto', alignSelf: 'flex-start', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getTasks(preparedData['tasks'])}
              </span>
            </div>
          )
          break;
        case 'photos':
          views.push(
            <div
              key={key}
              style={{ width: columnWidth, flexShrink: 0, ...OVERALL_MARGIN}}>
              {this.getPhotos(columnWidth, preparedData['photos'])}
            </div>
          )
          break;
        case 'date':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', width: columnWidth, alignSelf: 'flex-start', flexShrink: 0, overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {preparedData['date']}
              </span>
            </div>
          )
          break;
        case 'address':
          views.push(
            <div key={key} style={{ width: columnWidth, flexShrink: 0, overflow: 'auto', display: 'flex', alignSelf: 'flex-start', ...OVERALL_MARGIN}}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getAddress(preparedData['address'])}
              </span>
            </div>
          )
          break;
        case 'contactInfo':
          views.push(
            <div key={key}
              style={{ display: 'flex', width: columnWidth, flexShrink: 0, alignSelf: 'flex-start', overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getContactInfo(preparedData['contactInfo'])}
              </span>
            </div>
          )
          break;
        case 'jobType':
          views.push(
            <div key={key} style={{ display: 'flex', width: columnWidth, flexShrink: 0, alignSelf: 'flex-start', overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getJobType(preparedData['jobType'])}
              </span>
            </div>
          )
          break
        case 'contactId':
          views.push(
            <div
              key={key}
              style={{ display: 'flex', width: columnWidth, flexShrink: 0, alignSelf: 'flex-start', overflow: 'auto', ...OVERALL_MARGIN }}>
              <span
                style={{ fontSize: FONT_SIZE }}>
                {this.getContactId(preparedData['contactId'])}
              </span>
            </div>
          );
          break;
      }
    })

    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', minHeight: '48px', flexGrow: 1,
          alignItems: 'center', paddingLeft: 16, paddingRight: 16, flexShrink: 0,
          backgroundColor: this.props.backgroundColor}}>
        {views}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const args = state.reports.headers['SERVICE_HEADERS'];
  const argsData = state.reports.service;
  const props = {
    teamMembers: state.firebase.team.members.value
  }
  if (args && args.columnHeaders){
    props['headers'] = args.columnHeaders;
  } else {
    props['headers'] = [];
  }

  if (argsData){
    props['reportData'] = argsData
  } else {
    props['reportData'] = {}
  }
  return props;
}

export default connect(mapStateToProps)(ServiceRow)



// WEBPACK FOOTER //
// ./src/reports/service/ServiceRow.js